import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import {
  where,
  documentId,
  getDocs,
  query,
  collection,
  doc,
  getDoc,
  setDoc
} from "firebase/firestore";
import { db } from "../firebase-config";
import { async } from "@firebase/util";


export const Generator = () => {
  const [words, setWords] = useState([]);
  const [wordsResult, setWordsResult] = useState([]);
  const [selectedLang, setSelectedLang] = useState({generateWordsLang: "IT", selectedWordsLang: "ItalianWords"});
  // const [selectedWordsLang, setSelectedWordsLang] = useState("EnglishWords");
  const [errorMsg, setErrorMsg] = useState("");
  const disableBtn = useRef()
  // const selectedWordsLang = useRef()
  const langOptions = [
    {id:"en", name: "English Words", obj: {generateWordsLang: "EN", selectedWordsLang: "EnglishWords"}},
    {id: "sv", name: "Swedish Words", obj: {generateWordsLang: "SV", selectedWordsLang: "SwedishWords"}},
    {id: "de", name: "German Words", obj: {generateWordsLang: "DE", selectedWordsLang: "GermanWords"}},
    {id: "sv-e", name: "Easy swedish words", obj: {generateWordsLang: "SV-E", selectedWordsLang: "EasySwedishWords"}},
    {id: "dn", name: "Danish Words", obj: {generateWordsLang: "DN", selectedWordsLang: "DanishWords"}},
    {id: "fi", name: "Finnish Words", obj: {generateWordsLang: "FI", selectedWordsLang: "FinnishWords"}},
    {id: "et", name: "Estonian Words", obj: {generateWordsLang: "ET", selectedWordsLang: "EstonianWords"}},
    {id: "no", name: "Norwegian Words", obj: {generateWordsLang: "NO", selectedWordsLang: "NorwegianWords"}},
    {id: "it", name: "Italian Words", obj: {generateWordsLang: "IT", selectedWordsLang: "ItalianWords"}},
    {id: "fr", name: "French Words", obj: {generateWordsLang: "FR", selectedWordsLang: "FrenchWords"}},
]
  useEffect(() => {
    getWords()
  }, [selectedLang]);

  function getRandom(arr, n) {
    let result = new Array(n),
      len = arr.length,
      taken = new Array(len);
    if (n > len){
      setErrorMsg("More elements taken than available. Please Try Again..")
      throw new RangeError("getRandom: more elements taken than available");
    }
    while (n--) {
      let x = Math.floor(Math.random() * len);
      result[n] = arr[x in taken ? taken[x] : x];
      taken[x] = --len in taken ? taken[len] : len;
    }

    return result;
  }

  


  const wordsGen = (e) => {
    e.preventDefault();
    let randomnum1 = 0;
     let randomnum2 = 0;
      let randomnum3 = 0;
    setErrorMsg('')
    let randomWords = [];
    for (let i = 0; i < 1000; i++) {
      let check;
      const result = getRandom(words, 3);
      console.log(result)
      result.forEach((element, index) => {
        if (index === 1) {
          check =
            element.startsWith("l") ||
            element.endsWith("l") ||
            element.startsWith("i") ||
            element.endsWith("i") ||
            element.startsWith("j") ||
            element.endsWith("j") ||
            element.startsWith("h") ||
            element.startsWith("k") ||
            element.startsWith("b") ||
            element.endsWith("d") || element.startsWith("p") || element.startsWith("t") || element.endsWith("t");
        }
        //  randomnum1 = (Math.random() * (3 - 2.8) + 2.8).toFixed(3)
        //  randomnum2 = (Math.random() * (5.9 - 2.8) + 2.8).toFixed(3)
        // randomnum3 = (Math.random() * (4.8 - 3.5) + 3.5).toFixed(3)
      });
//**************************************************** */
      

      if(!check){
        let positions = result.map(w => w.length)
        console.log(positions)
        positions.pop()
        const secondPosition = positions.reduce((accumulator, currentValue, currentIndex) => {
             const sumPos = Number(accumulator) + parseInt(currentValue);
             return [...accumulator, sumPos];
        }, []);
        
        randomWords.push({word: result.join(''), correctPosition: secondPosition, correctAnswerTimes: [], wrongeAnswerTimes: []})
      }
       
    }
    randomWords.forEach((item, i) => {
      item.id = i;
    });
    console.log(randomWords);
    setWordsResult(randomWords);
  };

  // const getWords = useCallback(async () => {
  //   let queryWords;
  //   queryWords = query(collection(db, selectedLang.selectedWordsLang));

  //   const wordsDocs = await getDocs(queryWords);

  //   let wDocs = wordsDocs.docs;
    
  //   wDocs.map((doc) => {
  //     console.log(doc.data().words);
  //     return setWords(doc.data().words);
  //   });
  // }, [selectedLang]);


  const getWords = useCallback(async () => {
  const LOCO_API_KEY = 'wrqBHAWWPcw216HoCjAr1nBCCcW-tny1';

  try {
    const localeCode = selectedLang.generateWordsLang.toLowerCase();
    const response = await fetch(`/api/loco/export/locale/${localeCode}.json?key=${LOCO_API_KEY}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    const wordsArr = Object.values(data.words)
    // Transform the response data into an array of sentences
    // The exact transformation will depend on your Loco data structure
    // const wordsArray = Object.values(wordsArr).filter(item => 
    //   // Add any filtering conditions you need
    //   typeof item === 'string' && item.trim().length > 0
    // );
console.log("WORDSSSS", wordsArr)
    setWords(wordsArr);

  } catch (error) {
    console.error('Error fetching words from Loco:', error);
    setErrorMsg('Failed to load words. Please try again.');
  }
}, [selectedLang]);

useEffect(() => {
  checkIfWordsExist()
}, [])

const checkIfWordsExist = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "ReadingChainWords"))
    let allDocs = [];
    querySnapshot.forEach((doc) => {
       allDocs.push({...doc.data(), id: doc.id});
    })
    console.log(allDocs)
    // const isEmpty = data => Object.values(data).every(({ length }) => length);
    // for (const item of allDocs) {
    //   if(isEmpty(item)){ disableBtn.current.setAttribute("disabled", true)}
    //   // const querySnap = await getDocs(collection(db, `ReadingChainWords/${item.id}/words`))
    // }

}catch(err) {
    console.log(err)
  }
};


  const CLOUD_RUN_BASE_URL = process.env.REACT_APP_CLOUD_RUN_URL || "";

  const addToDB = useCallback(async () => {
    if (!wordsResult.length) {
      setErrorMsg("No words generated yet. Generate words first.");
      return;
    }
    try {
      const response = await fetch(
        `${CLOUD_RUN_BASE_URL}/TrainingData/chain?type=words`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: wordsResult.map((item) => ({
              wordId: item.id,
              language: selectedLang.generateWordsLang.toLowerCase(),
              value: item.word,
              correctPosition1: item.correctPosition[0],
              correctPosition2: item.correctPosition[1],
              correctAnswerTimes: item.correctAnswerTimes,
              wrongAnswerTimes: item.wrongeAnswerTimes,
            })),
          }),
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log("Chain inserted:", data);
      alert(`Success: ${data.message} (${data.insertedCount} items)`);
    } catch (error) {
      console.error("Error submitting chain to DB:", error);
      setErrorMsg("Failed to submit chain to database. Check console for details.");
    }
  }, [wordsResult, selectedLang, CLOUD_RUN_BASE_URL])

  const handleChange = (e) => {
    const langId = e.target.value;
  const lang = langOptions.find(u => u.id === langId);
  console.log(langId, lang)
    setSelectedLang(lang.obj)
  }
  
  return (
  <div className="container">
  <button className="" ref={disableBtn} onClick={addToDB}>Push to DB</button>
      <form className="op-form" onSubmit={wordsGen}>
      <label>
          <select onChange={handleChange}>
          {langOptions.map((option, index) => 
        <option key={index} value={option.id}>
         {option.name}
       </option>
          )}
          </select>
        </label>
        <input type="submit"  className="submitbtn" value="Generate words" />
      </form>
  {errorMsg ? <h2>{errorMsg}</h2> : <ol>{wordsResult.map((elem, key) => {
    return <li key={key}>word: {elem.word}{"    "}<span>{`[${elem.correctPosition.toString()}]`}</span></li>
  })}</ol>} 
  </div>
  )
};
